module.exports = __webpack_public_path__ + "move.a6a3a48645bcd0bcc298.svg";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/svg/move.svg
// module id = ../../../../../src/assets/svg/move.svg
// module chunks = 12